import './index.styl'

const watch_DIALOG_ID = 'watch-dialog'
const watch_DIALOG_CLOSE_ID = 'watch-dialog-close'

const WatchDialogPlugin = (Vue, options) => {
  Vue.prototype.$watchDialog = {
    init({watchDescription,publicAccountQRCode}) {
      const dom = document.getElementById(watch_DIALOG_ID)
      let domText = `
        <div id="${watch_DIALOG_ID}" class="watch-mask">
        <div class='container-box qrcodebg-notice'>
          <div class="title-notice">温馨提示</div>
          <div class="phone-notice">
            ${watchDescription}
          </div>
          <img class="qrcode-notice" src='${publicAccountQRCode}' alt=""/>
          <div class="desc-notice">已关注不再提示</div>

          <img id="${watch_DIALOG_CLOSE_ID}" class="closeBtn" src="http://image.wxopen.shenhudong.com/20210517/5debf8dacf2b0d751b1cba489be56d04.png?x-oss-process=style/uploadimg" alt=""/>
        </div>
        </div>
      `
      let qrcodeRes = document.body.insertAdjacentHTML('beforeEnd',domText)
      $(`#${watch_DIALOG_CLOSE_ID}`).off().click(() => {
        this.hide()
      })
      $(`.desc-notice`).off().click(() => {
        this.hide()
      })
      const openid = localStorage.getItem('WX_OPENID')
      if(openid) this.show()
      return qrcodeRes
    },
    show(){
      $(`#${watch_DIALOG_ID}`).show()
    },
    hide(){
      $(`#${watch_DIALOG_ID}`).hide()
    }
  }

}

export default WatchDialogPlugin